import { Dispatch } from "redux";
import {
  TrackList,
  getFormate,
  getTerritories,
} from "../../../actions/suggest";

export async function FetchAndDispatchActions(dispatch: Dispatch) {
  try {
    let keyword = "";
    const formateData = await getFormate(keyword);
    dispatch({ type: "SET_FORMAT", payload: formateData.result });

    const territoriesList = await getTerritories();
    dispatch({ type: "SET_TERRITORIES", payload: territoriesList.result.list });

    return {
      status: "success",
    };
  } catch (error) {
    console.log(error);
  }
}

export async function TrackDispatchAndActions(
  dispatch: Dispatch,
  data: any,
  signal: AbortSignal
) {
  try {
    const trackList: any = await TrackList(data, signal);
    dispatch({ type: "SET_TRACK_LIST", payload: trackList });
    return true;
  } catch (error) {
    return false;
    console.log(error);
  }
}
